import { THeaders } from '../../../types/request';

export const getSkipHashHeader = (headers: THeaders): string | null => {
  const skipHashHeader = headers.find(([key]) => key.toLowerCase() === 'VisibleViolations-Skip'.toLowerCase());

  if (!skipHashHeader) {
    return null;
  }

  return skipHashHeader[1];
};
